import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';

const ProgressStepper = ({ currentStep, movie, showtime, theater, selectedSeats }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedSeats } = useBooking();

  const steps = [
    {
      id: 'cinema',
      name: 'Select Cinema',
      path: movie ? `/booking/${movie.id}` : '/',
      completed: currentStep !== 'cinema'
    },
    {
      id: 'seats',
      name: 'Select Seat',
      path: '/seat-selection',
      completed: currentStep === 'snacks' || currentStep === 'payment'
    },
    {
      id: 'snacks',
      name: 'Grab Food',
      path: '/snacks',
      completed: currentStep === 'payment'
    },
    {
      id: 'payment',
      name: 'Payment',
      path: '/payment',
      completed: false
    }
  ];

  const handleStepClick = (step) => {
    // Don't allow clicking on current step or future steps
    if (step.id === currentStep || !step.completed) {
      return;
    }

    // Handle navigation based on step
    switch (step.id) {
      case 'cinema':
        if (movie) {
          navigate(`/booking/${movie.id}`);
        } else {
          navigate('/');
        }
        break;
      
      case 'seats':
        if (movie && showtime && theater) {
          navigate('/seat-selection', {
            state: {
              movie,
              showtime,
              theater,
              selectedSeats: selectedSeats || []
            }
          });
        } else {
          // If no booking data, go to home
          navigate('/');
        }
        break;
      
      case 'snacks':
        if (movie && showtime && theater && selectedSeats && selectedSeats.length > 0) {
          navigate('/snacks', {
            state: {
              movie,
              showtime,
              theater,
              selectedSeats
            }
          });
        } else {
          // If no seats selected, go to seat selection
          if (movie && showtime && theater) {
            navigate('/seat-selection', {
              state: {
                movie,
                showtime,
                theater
              }
            });
          } else {
            navigate('/');
          }
        }
        break;
      
      case 'payment':
        if (movie && showtime && theater && selectedSeats && selectedSeats.length > 0) {
          navigate('/payment', {
            state: {
              movie,
              showtime,
              theater,
              selectedSeats
            }
          });
        } else {
          // If no booking data, go to home
          navigate('/');
        }
        break;
      
      default:
        navigate('/');
    }
  };

  return (
    <ul className="stepper">
      {steps.map((step, index) => (
        <li
          key={step.id}
          className={`${step.completed ? 'completed' : ''} ${step.id === currentStep ? 'active' : ''} ${step.completed ? 'clickable' : ''}`}
          onClick={() => handleStepClick(step)}
          style={{ cursor: step.completed ? 'pointer' : 'default' }}
        >
          <span></span>
          {step.name}
        </li>
      ))}
    </ul>
  );
};

export default ProgressStepper;
